import { Col } from 'antd';
import React, { CSSProperties } from 'react';

import { BaseLayoutContainerStyled } from './styled';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const BaseLayout: React.FC<{ children: any; style?: CSSProperties }> = ({ children, style }) => (
  <BaseLayoutContainerStyled className='gx-m-0 overflow-y-auto overflow-x-hidden' style={style}>
    <Col className='gx-p-0 h-full' span={24}>
      {children}
    </Col>
  </BaseLayoutContainerStyled>
);

export default React.memo(BaseLayout);
